module.exports = false;



//////////////////
// WEBPACK FOOTER
// /Users/makebetter/Documents/sportsceneDash/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 0